// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__3EBKQ","rootSuccess":"CompleteLink_rootSuccess__3C7HX","rootFailure":"CompleteLink_rootFailure__3af3o","isDisabled":"CompleteLink_isDisabled__1WLHA"};